import { useLayoutEffect } from "react";

const CMS_MAIN_LAYOUT_BODY_CLASS = "cms-main-layout-active";

/**
 * Wraps authenticated `/cms` routes. Main column width is applied via
 * `body.cms-main-layout-active` in `public/assets/cms_custom.css` so the
 * AdminLTE shell (navbar + sidebar) stays full width; only `.content-wrapper`
 * content is centered (wrapping route output in a Bootstrap container would
 * break `.main-sidebar` positioning).
 */
export default function CmsMainLayout({ children }) {
  useLayoutEffect(() => {
    document.documentElement.classList.add(CMS_MAIN_LAYOUT_BODY_CLASS);
    document.body.classList.add(CMS_MAIN_LAYOUT_BODY_CLASS);
    return () => {
      document.documentElement.classList.remove(CMS_MAIN_LAYOUT_BODY_CLASS);
      document.body.classList.remove(CMS_MAIN_LAYOUT_BODY_CLASS);
    };
  }, []);

  return <>{children}</>;
}
